// extracted by mini-css-extract-plugin
module.exports = {"markdownList":"jf"};